import React from "react";
import styled from "@emotion/styled";
import { Dropdown } from "~/components/dropdown";
import { EmployeePicker } from "~/visuals/organisms/EmployeePickerFormField";
import { OrganizeBy } from "./types";
import { MenuAuthorizations } from "~/gql/types2";
import { ClientForm } from "~/components/forms/ClientForm";
import { ValueRenderer } from "~/components/forms/ValueContext";
import Updater from "~/components/forms/Updater";
import { IfAuthorized } from "~/components/IfAuthorized";

type ProjectFoldersControlAreaProps = {
  organizeBy: OrganizeBy;
  setOrganizeBy: React.Dispatch<OrganizeBy>;
  setProjectManager: React.Dispatch<string | null>;
};

// add margin left to the mdc menu to keep it inline with the dropdown elements
const ControlArea = styled("div")`
  display: grid;
  grid-auto-flow: column;

  & .mdc-menu {
    margin-left: 16px;
  }
`;

export const ProjectFoldersControlArea: React.FC<
  ProjectFoldersControlAreaProps
> = ({ organizeBy, setOrganizeBy, setProjectManager }) => {
  return (
    <ControlArea>
      <Dropdown
        items={["Drive", "Customer"] as OrganizeBy[]}
        label={"Organize By"}
        name={""}
        helperText={""}
        formatSelection={(x) => x}
        formatItem={(x) => x}
        selectedItem={organizeBy}
        required
        onSelected={(x) => setOrganizeBy(x!)}
      />

      <IfAuthorized menu={MenuAuthorizations.ViewAllProjectFolders}>
        <ClientForm
          initialValues={{ projectManager: null }}
          onSuccess={() => undefined}
        >
          <EmployeePicker
            formField="projectManager"
            label="Project Manager"
            helperText=""
            roleName="Project Manager"
          />
          <ValueRenderer
            render={(values) => (
              <Updater
                value={values.projectManager?.userPrincipalName || null}
                callback={setProjectManager}
              />
            )}
          />
        </ClientForm>
      </IfAuthorized>
    </ControlArea>
  );
};
